import { httpsCallable } from 'firebase/functions';
import { functions } from './firebase';

export interface ConfigWritePatch {
  [key: string]: unknown;
}

export const adminWriteConfig = httpsCallable<
  { docId: string; patch: ConfigWritePatch },
  { success: boolean; snapshotId: string }
>(functions, 'admin_writeConfig');

export const adminSetUserSuspended = httpsCallable<
  { uid: string; suspended: boolean; reason?: string },
  { success: boolean }
>(functions, 'admin_setUserSuspended');

export const adminDeleteUser = httpsCallable<
  { uid: string },
  { success: boolean }
>(functions, 'admin_deleteUser');

export const adminApproveDriverVerification = httpsCallable<
  { uid: string; approved: boolean; notes?: string },
  { success: boolean }
>(functions, 'admin_approveDriverVerification');

export const adminReviewDriverDocument = httpsCallable<
  {
    uid: string;
    docType: string;
    approved: boolean;
    reason?: string;
    expiresAt?: string;
  },
  { success: boolean }
>(functions, 'admin_reviewDriverDocument');

export const adminManualRefund = httpsCallable<
  { orderId: string; amountCents?: number; reason?: string },
  { success: boolean; refundId: string; amountCents: number }
>(functions, 'admin_manualRefund');

export const adminRecomputePayBreakdown = httpsCallable<
  { jobId: string },
  { success: boolean; payBreakdown: Record<string, unknown> }
>(functions, 'admin_recomputePayBreakdown');

export const adminCancelOrderForce = httpsCallable<
  { orderId: string; reason?: string },
  { success: boolean }
>(functions, 'admin_cancelOrderForce');
